import {connect} from 'react-redux';

import {isDefined} from '../../../../libs/shared/core/src/helpers/typescript/typeHelpers';
import {getFlatTeammates} from '../../../../libs/shared/core/src/store/data/teammates/commonTeammatesSelectors';
import {createSelector, makeMapStateToProps} from '../../../../srcCommon/helpers/reselectHelpers';
import {CardModel} from '../../../models/api/cardModel';
import {AppState} from '../../../store/appState';
import {getCustomFieldsForCards} from '../../../store/data/customFields/customFieldsSelectors';
import {CustomAttributesSection} from './customAttributesSection';

/*
 * Props.
 */

interface CustomAttributesSectionContainerProps {
  card: CardModel;
}

/*
 * Selectors.
 */

function getCard(_state: AppState, props: CustomAttributesSectionContainerProps) {
  return props.card;
}

function makeGetCustomAttributes() {
  return createSelector([getCustomFieldsForCards, getCard], (customFields, card) =>
    (card.customFieldAttributes || [])
      .map((customFieldAttribute) => {
        const customField = customFields[customFieldAttribute.id];

        return customField ? {customField, value: customFieldAttribute.value} : undefined;
      })
      .filter(isDefined),
  );
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<CustomAttributesSectionContainerProps>()(() => {
  const getCustomAttributes = makeGetCustomAttributes();
  return {
    customAttributes: getCustomAttributes,
    teammates: getFlatTeammates,
  };
});

export const CustomAttributesSectionContainer = connect(mapStateToProps)(CustomAttributesSection);
